export default state => state.address?.deliveryAddressList?.editedAddressIds || [];
